const authProvider = (apiUrl, httpClient) => ({
  login: ({ username, password }) => {
    return httpClient(apiUrl)
      .post(`/auth/login`, { email: username, password })
      .then((response) => response.data)
      .then((user) => {
        localStorage.setItem("user", JSON.stringify(user));
      })
      .catch((err) => {
        console.log("===> ", err);
        throw new Error(err);
      });
  },
  logout: () => {
    localStorage.removeItem("user");
    return Promise.resolve();
  },
  checkAuth: () => {
    const user = JSON.parse(localStorage.getItem("user"));
    return user && user.accessToken ? Promise.resolve() : Promise.reject();
  },
  checkError: (error) => {
    const status = error.status;
    if (status === 401 || status === 403) {
      localStorage.removeItem("user");
      return Promise.reject();
    }
    return Promise.resolve();
  },
  getPermissions: () => {
    const user = JSON.parse(localStorage.getItem("user"));
    const features = (user && user.features) || [];
    const role = user && user.role;
    return role ? Promise.resolve([role, ...features]) : Promise.reject();
  },
});

export default authProvider;
